import React, { useState, useEffect, useRef } from 'react';
import PlanningKaart from '../components/PlanningKaart';
import { useNavigate, useLocation } from "react-router-dom";
import WerkorderModal from "./WerkorderModal";

import api from '../services/api';
import ProjectMaandOverzicht from '../components/ProjectMaandOverzicht';
import { useAuth } from '../context/AuthContext';
import './WerkvoorbereiderPlanning.css';
import { isFeestdag, feestdagNaam } from '../utils/feestdagen';

// ISO 8601 weeknummer (maandag = start, week 1 bevat de eerste donderdag)
function isoWeek(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - dayNum + 3);
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  const firstDayNum = (firstThursday.getUTCDay() + 6) % 7;
  firstThursday.setUTCDate(firstThursday.getUTCDate() - firstDayNum + 3);
  return 1 + Math.round((d - firstThursday) / (7 * 24 * 3600 * 1000));
}
import WerkorderDetailModal from '../components/WerkorderDetailModal';
import CategoriePlanModal from '../components/CategoriePlanModal';
import DrukteKalender from '../components/DrukteKalender';


function DagMededelingModal({ monteurs, startDatum, onClose }) {
  const todayStr = (d => d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0'))(new Date());
  const [datum, setDatum] = useState(startDatum || todayStr);
  const [titel, setTitel] = useState('');
  const [bericht, setBericht] = useState('');
  const [prioriteit, setPrioriteit] = useState('normaal');
  const [doel, setDoel] = useState('iedereen');
  const [lijst, setLijst] = useState([]);
  const [bezig, setBezig] = useState(false);

  const laad = async (d) => {
    try { const r = await api.get('/dag-meldingen/week?start=' + d + '&eind=' + d); setLijst(r.data?.meldingen || []); }
    catch (e) { setLijst([]); }
  };
  useEffect(() => { laad(datum); }, [datum]);

  const opslaan = async () => {
    if (!bericht.trim()) { alert('Vul een bericht in'); return; }
    setBezig(true);
    try {
      await api.post('/dag-meldingen', { datum, titel: titel || null, bericht, prioriteit,
        monteur_id: doel === 'iedereen' ? null : parseInt(doel, 10), afdeling_id: null });
      setTitel(''); setBericht(''); setPrioriteit('normaal'); setDoel('iedereen');
      await laad(datum);
    } catch (e) { alert('Fout: ' + (e.response?.data?.error || e.message)); }
    finally { setBezig(false); }
  };

  const verwijder = async (id) => {
    if (!window.confirm('Mededeling verwijderen?')) return;
    try { await api.delete('/dag-meldingen/' + id); await laad(datum); }
    catch (e) { alert('Fout: ' + (e.response?.data?.error || e.message)); }
  };

  const inp = { width: '100%', padding: 10, borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14, boxSizing: 'border-box' };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, maxWidth: 480, width: '100%', maxHeight: '85vh', overflowY: 'auto', padding: 22 }}>
        <h2 style={{ margin: '0 0 16px', fontSize: 20 }}>{'\uD83D\uDCCC'} Mededeling voor monteurs</h2>
        <label style={{ fontSize: 13, fontWeight: 600 }}>Datum</label>
        <input type="date" value={datum} onChange={e => setDatum(e.target.value)} style={{ ...inp, marginBottom: 12 }} />
        <label style={{ fontSize: 13, fontWeight: 600 }}>Voor wie</label>
        <select value={doel} onChange={e => setDoel(e.target.value)} style={{ ...inp, marginBottom: 12 }}>
          <option value="iedereen">Iedereen</option>
          {monteurs.map(m => (
            <option key={m.id} value={m.id}>{m.voornaam ? (m.voornaam + ' ' + (m.achternaam || '')) : (m.naam || ('Monteur ' + m.id))}</option>
          ))}
        </select>
        <label style={{ fontSize: 13, fontWeight: 600 }}>Titel (optioneel)</label>
        <input value={titel} onChange={e => setTitel(e.target.value)} placeholder="Bijv. Wegafsluiting Centrum" style={{ ...inp, marginBottom: 12 }} />
        <label style={{ fontSize: 13, fontWeight: 600 }}>Bericht</label>
        <textarea value={bericht} onChange={e => setBericht(e.target.value)} rows={4} placeholder="Wat moeten de monteurs weten?" style={{ ...inp, marginBottom: 12, resize: 'vertical' }} />
        <label style={{ fontSize: 13, fontWeight: 600 }}>Prioriteit</label>
        <select value={prioriteit} onChange={e => setPrioriteit(e.target.value)} style={{ ...inp, marginBottom: 16 }}>
          <option value="normaal">Normaal</option>
          <option value="hoog">Hoog (rood)</option>
        </select>
        <div style={{ display: 'flex', gap: 10, marginBottom: 18 }}>
          <button onClick={opslaan} disabled={bezig} style={{ flex: 1, padding: 12, border: 'none', borderRadius: 8, background: '#3b82f6', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>{bezig ? 'Bezig\u2026' : 'Toevoegen'}</button>
          <button onClick={onClose} style={{ padding: 12, border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer' }}>Sluiten</button>
        </div>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#6b7280', marginBottom: 8 }}>Mededelingen op {datum} ({lijst.length})</div>
        {lijst.length === 0 && <div style={{ fontSize: 13, color: '#9ca3af' }}>Nog geen mededelingen voor deze dag.</div>}
        {lijst.map(m => (
          <div key={m.id} style={{ border: '1px solid #e5e7eb', borderLeft: '4px solid ' + (m.prioriteit === 'hoog' ? '#ef4444' : '#3b82f6'), borderRadius: 8, padding: 10, marginBottom: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <div style={{ minWidth: 0 }}>
                {m.titel && <div style={{ fontWeight: 700, fontSize: 14 }}>{m.titel}</div>}
                <div style={{ fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap' }}>{m.bericht}</div>
                <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>{m.monteur_naam ? ('\u2192 ' + m.monteur_naam) : '\u2192 Iedereen'}{m.aangemaakt_door_naam ? (' \u00B7 ' + m.aangemaakt_door_naam) : ''}</div>
              </div>
              <button onClick={() => verwijder(m.id)} title="Verwijderen" style={{ border: 'none', background: 'transparent', color: '#ef4444', cursor: 'pointer', fontSize: 18 }}>{'\uD83D\uDDD1'}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


const WerkvoorbereiderPlanning = () => {
  console.log("🚀 WERKVOORBEREIDER PLANNING LOADED - MULTIDAG");
  const { gebruiker, hasPermission } = useAuth();
  const [autoPlanAan, setAutoPlanAan] = useState(null);   // null = nog onbekend
  const [autoPlanBusy, setAutoPlanBusy] = useState(false);

  const laadAutoPlan = async () => {
    try {
      const res = await api.get('/planning/afdeling-instelling');
      const mijn = (res.data.afdelingen || []).find(a => a.id === gebruiker?.afdeling_id);
      setAutoPlanAan(mijn ? !!mijn.auto_herplanning_enabled : null);
    } catch (e) { console.error('Fout laden auto-plannen:', e); }
  };

  const toggleAutoPlan = async () => {
    if (!hasPermission('planning:bewerken') || autoPlanAan === null) return;
    const nieuw = !autoPlanAan;
    const afdNaam = autoPlanNaam();
    if (!window.confirm('Auto-plannen voor afdeling ' + afdNaam + ' op ' + (nieuw ? 'AAN' : 'UIT') + ' zetten?\n\nDit geldt voor de hele afdeling: niet-afgeronde werkorders schuiven ' + (nieuw ? 'voortaan automatisch door' : 'niet meer automatisch door (blijven in Ongepland)') + '.')) return;
    setAutoPlanBusy(true);
    try {
      await api.put('/planning/afdeling-instelling/' + gebruiker.afdeling_id, { enabled: nieuw });
      setAutoPlanAan(nieuw);
    } catch (e) {
      console.error('Fout zetten auto-plannen:', e);
      alert('Kon auto-plannen niet wijzigen');
    } finally { setAutoPlanBusy(false); }
  };

  const autoPlanNaam = () => {
    const m = monteurs.find(x => x.afdeling_id === gebruiker?.afdeling_id);
    return gebruiker?.afdeling_naam || (m && m.afdeling_naam) || ('afdeling ' + (gebruiker?.afdeling_id ?? '?'));
  };
  const navigate = useNavigate();
  const [showWerkorderModal, setShowWerkorderModal] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("gebruiker");
    navigate("/login");
  };

  const [werkorders, setWerkorders] = useState([]);
  const [ongeplandeWerkorders, setOngeplandeWerkorders] = useState([]);
  const [monteurs, setMonteurs] = useState([]);
  const isOnderaannemer = (m) => String(m.gebruikersnaam || '').startsWith('oa_') || m.id === 61 || String(m.achternaam || '').includes('onderaannemer');
  const sorteerMonteurs = (lijst) => [...lijst].sort((a, b) => (isOnderaannemer(a) ? 1 : 0) - (isOnderaannemer(b) ? 1 : 0));

  const [loading, setLoading] = useState(true);
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const [dagMeldingen, setDagMeldingen] = useState([]);
  const [meldingReload, setMeldingReload] = useState(0);
  const [meldingDatum, setMeldingDatum] = useState(null);
  const [draggedWerkorder, setDraggedWerkorder] = useState(null);
  const [compactMode, setCompactMode] = useState(() => {
    try { return localStorage.getItem('planning-compact') === 'true'; } catch (e) { return false; }
  });
  useEffect(() => {
    try { localStorage.setItem('planning-compact', compactMode); } catch (e) {}
  }, [compactMode]);
  const weekHoverTimer = useRef(null);
  const [weekHoverDir, setWeekHoverDir] = useState(null);
  const [kaartMode, setKaartMode] = useState(false);
  const handleWeekDragEnter = (dir) => (e) => {
    e.preventDefault();
    if (!draggedWerkorder) return;
    setWeekHoverDir(dir);
    if (weekHoverTimer.current) clearTimeout(weekHoverTimer.current);
    weekHoverTimer.current = setTimeout(() => {
      if (dir === 'prev') prevWeek(); else nextWeek();
      setWeekHoverDir(null);
      weekHoverTimer.current = null;
    }, 600);
  };
  const handleWeekDragLeave = () => {
    if (weekHoverTimer.current) {
      clearTimeout(weekHoverTimer.current);
      weekHoverTimer.current = null;
    }
    setWeekHoverDir(null);
  };
  const [selectedWerkorderId, setSelectedWerkorderId] = useState(null);
  const [cursussen, setCursussen] = useState([]);
  const [voertuigAfspraken, setVoertuigAfspraken] = useState([]);
  const [categoriePlanning, setCategoriePlanning] = useState([]);
  const [roosterVrij, setRoosterVrij] = useState([]);
  const [huurBlokken, setHuurBlokken] = useState([]);
  const [showCategorieModal, setShowCategorieModal] = useState(false);
  const [verwachtOnderhoud, setVerwachtOnderhoud] = useState({});
  const [verwachtOpen, setVerwachtOpen] = useState(false);
  const [ongeplandZoek, setOngeplandZoek] = useState('');
  const [wachtConfirm, setWachtConfirm] = useState(null);
  const [nachtConfirm, setNachtConfirm] = useState(null); // 'af|mid|datum' / 'her|cpId' / 'ext|cpId'
  const vFmt = d => d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
  const verwachtReqId = useRef(0);
  const laadVerwacht = () => {
    const rid = ++verwachtReqId.current;
    const ma = new Date(currentWeek);
    ma.setDate(ma.getDate() - ((ma.getDay() + 7) % 7)); // zondag als weekstart, zoals de grid
    const zo = new Date(ma); zo.setDate(zo.getDate() + 6);
    api.get('/forecast/drukte/verwacht', { params: { start: vFmt(ma), eind: vFmt(zo), _t: Date.now() } })
      .then(r => { if (rid === verwachtReqId.current) setVerwachtOnderhoud(r.data.items || {}); })
      .catch(err => console.error('[verwacht]', err.message));
  };
  useEffect(() => { laadVerwacht(); }, [currentWeek]);
  const [showOvertijdModal, setShowOvertijdModal] = useState(false);
  const [overtijdInfo, setOvertijdInfo] = useState(null);

  // State voor drop popup
  const [showDropModal, setShowDropModal] = useState(false);
    const [dropInfo, setDropInfo] = useState(null);

  // === Project view (gezamenlijke planning) ===
  const [viewMode, setViewMode] = useState('eigen'); // 'eigen' | 'project'
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [toonProjMaand, setToonProjMaand] = useState(false);
  const [availableProjects, setAvailableProjects] = useState([]);
  const [projectMeta, setProjectMeta] = useState(null);

  // Dienst kleuren (aanpasbaar)
  const dienstKleuren = {
    nachtdienst_bg: '#ede9fe',      // licht paars achtergrond
    nachtdienst_border: '#7c3aed',  // paars border
    nachtdienst_text: '#5b21b6',    // paars tekst
    storingsdienst_bg: '#fef3c7',   // licht geel achtergrond
    storingsdienst_border: '#f59e0b', // geel border
    storingsdienst_text: '#92400e',  // donker geel tekst
    cursus_bg: '#d1fae5',           // licht groen
    cursus_border: '#10b981',       // groen border
    cursus_text: '#065f46',         // donker groen tekst
    categorie_bg: '#dbeafe',        // licht blauw
    categorie_border: '#3b82f6',    // blauw border
    categorie_text: '#1e40af'       // donker blauw tekst
  };

  // Haal projecten op voor gezamenlijke-planning dropdown (1x)
  useEffect(() => {
    api.get('/projecten/voor-planning-dropdown/lijst')
      .then(res => setAvailableProjects(res.data.projecten || []))
      .catch(() => setAvailableProjects([]));
  }, []);

  // URL param ?project=X — start direct in project-modus
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const projId = params.get('project');
    if (projId && availableProjects.length > 0) {
      const pid = parseInt(projId);
      const proj = availableProjects.find(p => p.id === pid);
      if (proj) {
        setViewMode('project');
        setSelectedProjectId(pid);
        if (proj.earliest_planned_date) {
          setCurrentWeek(new Date(proj.earliest_planned_date));
        }
      }
    }
    // eslint-disable-next-line
  }, [location.search, availableProjects]);

  useEffect(() => {
    laadAutoPlan();
    fetchData();
    // eslint-disable-next-line
  }, [currentWeek, viewMode, selectedProjectId]);

  // dag-meldingen badge laden
  useEffect(() => {
    const m = getMonday(currentWeek);
    const su = new Date(m); su.setDate(m.getDate() + 6);
    const pad = n => String(n).padStart(2, '0');
    const sd = m.getFullYear() + '-' + pad(m.getMonth() + 1) + '-' + pad(m.getDate());
    const ed = su.getFullYear() + '-' + pad(su.getMonth() + 1) + '-' + pad(su.getDate());
    api.get('/dag-meldingen/week?start=' + sd + '&eind=' + ed)
       .then(r => setDagMeldingen(r.data?.meldingen || []))
       .catch(() => setDagMeldingen([]));
  }, [currentWeek, meldingReload]);

  const fetchData = async () => {
    // === Project-modus (gezamenlijke planning) ===
    if (viewMode === 'project' && selectedProjectId) {
      try {
        setLoading(true);
        const monday = getMonday(currentWeek);
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        const startStr = monday.toISOString().split('T')[0];
        const endStr = sunday.toISOString().split('T')[0];
        const r = await api.get('/planning/project/' + selectedProjectId + '?start_datum=' + startStr + '&eind_datum=' + endStr);
        setWerkorders(r.data.werkorders || []);
        setOngeplandeWerkorders(r.data.ongeplandeWerkorders || []);
        setMonteurs(sorteerMonteurs(r.data.monteurs || []));
        setCursussen(r.data.cursussen || []);
        setCategoriePlanning([]);
        setHuurBlokken([]);
        setProjectMeta(r.data.project || null);
        setLoading(false);
      } catch (err) {
        console.error('Fout bij project planning:', err);
        setLoading(false);
      }
      return;
    }
    setProjectMeta(null);
    try {
      setLoading(true);

      const startOfWeek = getMonday(currentWeek);
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(endOfWeek.getDate() + 6);

      const startStr = startOfWeek.toISOString().split('T')[0];
      const endStr = endOfWeek.toISOString().split('T')[0];

      const [werkordersRes, monteursRes, ongeplandRes, cursussenRes, categoriePlanningRes, huurRes] = await Promise.all([
        api.get('/planning/kalender?start_datum=' + startStr + '&eind_datum=' + endStr),
        api.get('/gebruikers'),
        api.get('/planning/ongepland'),
        api.get('/cursussen/week?start=' + startStr + '&eind=' + endStr).catch(() => ({ data: { data: [] } })),
        api.get('/categorie-planning?start=' + startStr + '&eind=' + endStr).catch(() => ({ data: { data: [] } })),
        api.get('/inhuur/planning/week?start=' + startStr).catch(() => ({ data: [] }))
      ]);

      const afdelingId = gebruiker?.afdeling_id;

      const gefilterdeWerkorders = afdelingId
        ? (werkordersRes.data.werkorders || []).filter(wo => wo.afdeling_id === afdelingId)
        : werkordersRes.data.werkorders || [];

      const alleMonteurs = (monteursRes.data.gebruikers || []).filter(g => g.in_planning);
      const gefilterdeMonteurs = afdelingId
        ? alleMonteurs.filter(m => m.afdeling_id === afdelingId)
        : alleMonteurs;

      const ongepland = afdelingId
        ? (ongeplandRes.data.werkorders || []).filter(wo => wo.afdeling_id === afdelingId)
        : ongeplandRes.data.werkorders || [];

      setWerkorders(gefilterdeWerkorders);
      setMonteurs(sorteerMonteurs(gefilterdeMonteurs));
      setOngeplandeWerkorders(ongepland);
      setCursussen(cursussenRes?.data?.data || []);
      try { const vaRes = await api.get('/wagenpark/afspraken?start=' + startStr + '&eind=' + endStr); setVoertuigAfspraken(Array.isArray(vaRes?.data) ? vaRes.data : []); } catch (e) { /* optioneel */ }
      setCategoriePlanning(categoriePlanningRes?.data?.data || []);
      try { const rvRes = await api.get('/rooster-vrij'); setRoosterVrij(rvRes?.data?.data || []); } catch (e) { /* optioneel */ }
      setHuurBlokken(huurRes?.data || []);
    } catch (error) {
      console.error('Fout bij laden planning:', error);
    } finally {
      setLoading(false);
    }
  };

  // Eerste dag (zondag) van de week waarin `date` valt
  const getMonday = (date) => {
    const d = new Date(date);
    d.setDate(d.getDate() - d.getDay());
    return d;
  };

  const getWeekDays = () => {
    const monday = getMonday(currentWeek);
    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(monday);
      day.setDate(day.getDate() + i);
      days.push(day);
    }
    return days;
  };

  // Check of monteur nachtdienst heeft deze week
  const heeftNachtdienst = (monteur, weekStart) => {
    if (!monteur.nachtdienst_start || !monteur.nachtdienst_interval_weken) return false;
    const s = new Date(monteur.nachtdienst_start);
    const startD = new Date(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate());
    const weekD = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate());
    const diffDagen = Math.round((weekD - startD) / 86400000);
    const diffWeken = Math.floor(diffDagen / 7);
    return diffDagen >= 0 && diffWeken % monteur.nachtdienst_interval_weken === 0;
  };

  // Check of monteur storingsdienst heeft deze week
  const heeftStoringsdienst = (monteur, weekStart) => {
    if (!monteur.storingsdienst_start || !monteur.storingsdienst_interval_weken) return false;
    const s = new Date(monteur.storingsdienst_start);
    const startD = new Date(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate());
    const weekD = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate());
    const diffDagen = Math.round((weekD - startD) / 86400000);
    const diffWeken = Math.floor(diffDagen / 7);
    return diffDagen >= 0 && diffWeken % monteur.storingsdienst_interval_weken === 0;
  };

  // Dienst per DAG: nachtweek start zondag, storingsweek start maandag
  const heeftDienstOpDag = (monteur, datum, type) => {
    const startVal = monteur[type + 'dienst_start'];
    const interval = monteur[type + 'dienst_interval_weken'];
    if (!startVal || !interval) return false;
    const d = new Date(datum.getFullYear(), datum.getMonth(), datum.getDate());
    if (type === 'nacht' && (d.getDay() === 5 || d.getDay() === 6)) return false; // nacht is zo t/m do (5 nachten)
    const offset = type === 'storings' ? ((d.getDay() + 6) % 7) : d.getDay();
    const weekD = new Date(d); weekD.setDate(weekD.getDate() - offset);
    const s = new Date(startVal);
    const startD = new Date(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate());
    const diffDagen = Math.round((weekD - startD) / 86400000);
    const diffWeken = Math.floor(diffDagen / 7);
    return diffDagen >= 0 && diffWeken % interval === 0;
  };

  // Cursussen voor monteur op datum
  const getVoertuigAfsprakenFor = (monteurId, date) => {
    const dateStr = vFmt(date);
    return voertuigAfspraken.filter(a => (monteurId == null ? !a.bestuurder_id : a.bestuurder_id === monteurId) && a.datum === dateStr);
  };
  const VA_ICON = { apk: '🔍', onderhoud: '🔧', banden: '🛞', schade: '🛠️' };
  const VA_LABEL = { apk: 'APK', onderhoud: 'Onderhoud', banden: 'Banden', schade: 'Schade' };
  const getCursussenForMonteurAndDate = (monteurId, date) => {
    const dateStr = vFmt(date);
    return cursussen.filter(c => c.gebruiker_id === monteurId && c.gepland_op && c.gepland_op.startsWith(dateStr));
  };

  const isRoosterVrij = (monteurId, date) => {
    const dow = date.getDay();
    const matches = roosterVrij.filter(rv => rv.gebruiker_id === monteurId && rv.dag_van_week === dow);
    for (const rv of matches) {
      if (rv.frequentie === 'wekelijks') return true;
      const van = new Date(rv.vanaf_datum); van.setHours(0,0,0,0);
      const d0 = new Date(date); d0.setHours(0,0,0,0);
      const weken = Math.floor((d0 - van) / (7*24*3600*1000));
      if (weken >= 0 && weken % 2 === 0) return true;
    }
    return false;
  };

  const getCategoriePlanningForMonteurAndDate = (monteurId, date) => {
    const dateStr = vFmt(date);
    return categoriePlanning.filter(cp => cp.gebruiker_id === monteurId && cp.gepland_op && cp.gepland_op.startsWith(dateStr));
  };

  const handleDragStart = (e, werkorder) => {
    setDraggedWerkorder(werkorder);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = async (e, datum, monteurId) => {
    const vwo = e.dataTransfer.getData('verwacht_wo_id');
    if (vwo) {
      e.preventDefault();
      try {
        await api.post('/planning/plan', { werkorder_id: vwo, geplande_datum: vFmt(datum), monteur_id: monteurId });
        laadVerwacht();
        fetchData();
      } catch (err) { alert('Plannen mislukt: ' + (err.response?.data?.error || err.message)); }
      return;
    }
    const vid = e.dataTransfer.getData('verwacht_id');
    if (vid) {
      e.preventDefault();
      const vdatum = e.dataTransfer.getData('verwacht_datum');
      const doel = vFmt(datum);
      if (vdatum && doel !== vdatum) { alert('De datum van verwacht onderhoud staat vast — sleep binnen dezelfde kolom naar een monteur.'); return; }
      try {
        await api.put('/forecast/drukte/verwacht/' + vid + '/monteur', { monteur_id: monteurId });
        laadVerwacht();
      } catch (err) { alert('Koppelen mislukt: ' + (err.response?.data?.message || err.message)); }
      return;
    }
    e.preventDefault();
    if (!draggedWerkorder) return;

    // AFW_VOORAF: monteur afwezig (verlof/ziek) op deze dag? -> blokkeer vooraf
    const _dStr = vFmt(datum);
    const _afw = getCategoriePlanningForMonteurAndDate(monteurId, datum).filter(cp => cp.categorie_id === 4 || cp.categorie_id === 5);
    if (_afw.length > 0) {
      const _bezet = _afw.reduce((s, cp) => s + (parseFloat(cp.aantal_uren) || 0), 0);
      const _nodig = parseFloat(draggedWerkorder.verwachte_uren) || 1;
      if (_bezet + _nodig > 8) {
        const _mon = monteurs.find(m => m.id === monteurId);
        const _naam = _mon ? (_mon.voornaam + ' ' + _mon.achternaam) : 'Monteur';
        const _heeftZiek = _afw.some(cp => cp.categorie_id === 4);
        const _heeftVerlof = _afw.some(cp => cp.categorie_id === 5);
        let _zin;
        if (_heeftZiek && _heeftVerlof) _zin = 'is ziek en heeft verlof';
        else if (_heeftZiek) _zin = 'is ziek';
        else _zin = 'heeft verlof';
        alert('\u26A0\uFE0F ' + _naam + ' ' + _zin + ' op ' + _dStr + ' - niet inplanbaar.');
        setDraggedWerkorder(null);
        return;
      }
    }

    // Check of monteur over 8 uur komt
    const huidigeUren = getTotalUrenForMonteurAndDate(monteurId, datum);
    const nieuweUren = parseFloat(draggedWerkorder.verwachte_uren) || 1;
    const totaalUren = huidigeUren + nieuweUren;

    if (totaalUren > 8) {
      setOvertijdInfo({
        datum,
        monteurId,
        huidigeUren,
        nieuweUren,
        totaalUren,
        werkorder: draggedWerkorder
      });
      setShowOvertijdModal(true);
      return;
    }

    // Als werkorder ongepland is, direct toevoegen
    if (!draggedWerkorder.planning_id) {
      await doPlannen("toevoegen", datum, monteurId);
      return;
    }
    setDropInfo({ datum, monteurId, werkorder: draggedWerkorder });
    setShowDropModal(true);
  };

  const doPlannen = async (actie, datum, monteurId) => {
    try {
      const datumStr = vFmt(datum);

      if (actie === 'toevoegen') {
        // Voeg toe aan nieuwe dag
        await api.post('/planning/plan', {
          werkorder_id: draggedWerkorder.id,
          geplande_datum: datumStr,
          monteur_id: monteurId
        });
      } else if (actie === 'verplaatsen') {
        await api.put('/planning/verplaats/' + draggedWerkorder.planning_id, {
          nieuwe_datum: datumStr,
          monteur_id: monteurId
        });
      }

      fetchData();
      setDraggedWerkorder(null);
      setShowDropModal(false);
      setDropInfo(null);
    } catch (error) {
      console.error('Fout bij plannen:', error);
      alert('Fout bij plannen werkorder');
    }
  };

  const handleDropModalChoice = (actie) => {
    if (dropInfo) {
      doPlannen(actie, dropInfo.datum, dropInfo.monteurId);
    }
  };

  const handleVerwijderVanDag = async (werkorder, e) => {
    e.stopPropagation();
    if (!werkorder.planning_id) return;

    if (!window.confirm('Werkorder #' + werkorder.id + ' verwijderen van deze dag?')) return;

    try {
      await api.delete('/planning/unplan/' + werkorder.planning_id);
      fetchData();
    } catch (error) {
      console.error('Fout bij verwijderen:', error);
      alert('Fout bij verwijderen van dag');
    }
  };

  const getWerkordersForMonteurAndDate = (monteurId, date) => {
    const dateStr = vFmt(date);
    return werkorders.filter(wo =>
      wo.monteur_id === monteurId &&
      wo.geplande_datum?.startsWith(dateStr)
    );
  };
  // Bereken totale uren per monteur per dag
  const getTotalUrenForMonteurAndDate = (monteurId, date) => {
    const dayWerkorders = getWerkordersForMonteurAndDate(monteurId, date);
    return dayWerkorders.reduce((total, wo) => total + (parseFloat(wo.verwachte_uren) || 1), 0);
  };

  const nextWeek = () => {
    const next = new Date(currentWeek);
    next.setDate(next.getDate() + 7);
    setCurrentWeek(next);
  };

  const prevWeek = () => {
    const prev = new Date(currentWeek);
    prev.setDate(prev.getDate() - 7);
    setCurrentWeek(prev);
  };

  const thisWeek = () => {
    setCurrentWeek(new Date());
  };

  const weekDays = getWeekDays();
  const weekStart = weekDays[0].toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' });
  const weekEnd = weekDays[6].toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
  const weekStartDate = getMonday(currentWeek);

  if (loading) return <div className="loading">⏳ Laden...</div>;

  return (
    <div className={"werkvoorbereider-planning" + (compactMode ? " compact-mode" : "")}>
      <div className="dashboard-container">
        {kaartMode && <PlanningKaart week={currentWeek} />}
        <div className="dashboard-header">
          <h1>📅 Planning Kalender</h1>
          {autoPlanAan !== null && (
            <div
              onClick={hasPermission('planning:bewerken') && !autoPlanBusy ? toggleAutoPlan : undefined}
              title={hasPermission('planning:bewerken') ? 'Klik om aan/uit te zetten' : 'Alleen-lezen — je mag dit niet wijzigen'}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 10,
                marginTop: 8, padding: '8px 16px', borderRadius: 10, fontWeight: 700, fontSize: 15,
                cursor: hasPermission('planning:bewerken') && !autoPlanBusy ? 'pointer' : 'default',
                userSelect: 'none', border: '2px solid ' + (autoPlanAan ? '#10b981' : '#9ca3af'),
                background: autoPlanAan ? '#d1fae5' : '#f3f4f6',
                color: autoPlanAan ? '#065f46' : '#374151',
                opacity: autoPlanBusy ? 0.6 : 1
              }}
            >
              <span style={{ fontSize: 18 }}>{autoPlanAan ? '🟢' : '⚪'}</span>
              Auto-plannen {autoPlanAan ? 'AAN' : 'UIT'} — {autoPlanNaam()}
              {hasPermission('planning:bewerken') && (
                <span style={{ fontWeight: 500, fontSize: 13, opacity: 0.7 }}>
                  ({autoPlanBusy ? 'bezig…' : 'klik om te wijzigen'})
                </span>
              )}
            </div>
          )}
        </div>
        {hasPermission('planning:bewerken') && (
          <a href="/monteur-koppels" style={{
            display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 8, marginLeft: 8,
            padding: '8px 16px', borderRadius: 10, fontWeight: 700, fontSize: 15,
            border: '2px solid #3b82f6', background: '#dbeafe', color: '#1e40af', textDecoration: 'none'
          }}>
            <span style={{ fontSize: 18 }}>{'\uD83D\uDD17'}</span> Teams per week
          </a>
        )}
        <div style={{ marginBottom: 8 }}>
          <button onClick={() => setToonProjMaand(o => !o)}
            style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #c7d2fe', background: toonProjMaand ? '#e0e7ff' : 'white', color: '#3730a3', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>
            {toonProjMaand ? 'Projecten per maand sluiten' : 'Projecten per maand'}
          </button>
        </div>
        {toonProjMaand && (
          <ProjectMaandOverzicht onOpen={(pid, datum) => {
            setViewMode('project');
            setSelectedProjectId(pid);
            if (datum) setCurrentWeek(new Date(datum + 'T12:00:00'));
            setToonProjMaand(false);
          }} />
        )}
        {/* === Gezamenlijke planning view-switch === */}
        <div style={{ padding: '12px 16px', background: viewMode === 'project' ? '#eff6ff' : 'transparent', border: viewMode === 'project' ? '1px solid #bfdbfe' : '1px solid transparent', borderRadius: 8, marginBottom: 8, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <label style={{ fontWeight: 600, fontSize: 14 }}>Toon:</label>
          <select
            value={viewMode === 'eigen' ? 'eigen' : 'project:' + selectedProjectId}
            onChange={(e) => {
              const v = e.target.value;
              if (v === 'eigen') {
                setViewMode('eigen');
                setSelectedProjectId(null);
              } else if (v.startsWith('project:')) {
                const pid = parseInt(v.split(':')[1]);
                setViewMode('project');
                setSelectedProjectId(pid);
                // Spring naar de week van de eerste geplande werkorder
                const proj = availableProjects.find(p => p.id === pid);
                if (proj && proj.earliest_planned_date) {
                  setCurrentWeek(new Date(proj.earliest_planned_date));
                }
              }
            }}
            style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 14, minWidth: 320, cursor: 'pointer' }}
          >
            <option value="eigen">📅 Mijn afdeling</option>
            {availableProjects.length > 0 && (
              <optgroup label="🔧 Projecten">
                {availableProjects.map(p => (
                  <option key={p.id} value={'project:' + p.id}>
                    {p.project_code ? p.project_code + ' — ' : ''}{p.naam}{p.eigenaar_afdeling_naam ? ' · ' + p.eigenaar_afdeling_naam : ''}
                  </option>
                ))}
              </optgroup>
            )}
          </select>
          {viewMode === 'project' && projectMeta && (
            <span style={{ fontSize: 13, color: '#1e40af', fontWeight: 500 }}>
              📌 {projectMeta.naam}
              {projectMeta.afdelingen && projectMeta.afdelingen.length > 0 && (
                <span style={{ marginLeft: 8, color: '#475569' }}>
                  · Afdelingen: {projectMeta.afdelingen.map(a => a.naam).join(', ')}
                </span>
              )}
            </span>
          )}
        </div>

        <div className="planning-header">
          <div className="week-navigation">
            <button
              onClick={prevWeek}
              onDragOver={(e) => e.preventDefault()}
              onDragEnter={handleWeekDragEnter('prev')}
              onDragLeave={handleWeekDragLeave}
              className="btn-secondary"
              style={weekHoverDir === 'prev' ? { background: '#3b82f6', color: 'white', boxShadow: '0 0 0 2px #1d4ed8' } : {}}
            >← Vorige week</button>
            <button onClick={thisWeek} className="btn-primary">Deze week</button>
            <h2>Week {isoWeek(weekDays[3])}: {weekStart} - {weekEnd}</h2>
            <button
              onClick={nextWeek}
              onDragOver={(e) => e.preventDefault()}
              onDragEnter={handleWeekDragEnter('next')}
              onDragLeave={handleWeekDragLeave}
              className="btn-secondary"
              style={weekHoverDir === 'next' ? { background: '#3b82f6', color: 'white', boxShadow: '0 0 0 2px #1d4ed8' } : {}}
            >Volgende week →</button>
            <select
              value={currentWeek.getMonth()}
              onChange={(e) => setCurrentWeek(new Date(currentWeek.getFullYear(), parseInt(e.target.value), 1))}
              title="Spring naar maand"
              style={{ marginLeft: 8, padding: '7px 8px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13, cursor: 'pointer' }}
            >
              {['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'].map((m, i) => (
                <option key={i} value={i}>{m}</option>
              ))}
            </select>
            <select
              value={currentWeek.getFullYear()}
              onChange={(e) => setCurrentWeek(new Date(parseInt(e.target.value), currentWeek.getMonth(), 1))}
              title="Spring naar jaar"
              style={{ marginLeft: 4, padding: '7px 8px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13, cursor: 'pointer' }}
            >
              {Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - 1 + i).map(j => (
                <option key={j} value={j}>{j}</option>
              ))}
            </select>
            <button
              onClick={() => setShowCategorieModal(true)}
              style={{ marginLeft: 16, padding: '8px 16px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}
            >
              + Werkoverleg / extra plannen
            </button>
            <button onClick={() => { const d = new Date(); const pad = n => String(n).padStart(2, '0'); setMeldingDatum(d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())); }} style={{ marginLeft: 10, padding: '8px 16px', background: '#0ea5e9', color: 'white', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>📌 Mededeling</button>
            {meldingDatum !== null && <DagMededelingModal monteurs={monteurs} startDatum={meldingDatum} onClose={() => { setMeldingDatum(null); setMeldingReload(x => x + 1); }} />}
            <button
              onClick={() => setCompactMode(v => !v)}
              className={"compact-toggle" + (compactMode ? " actief" : "")}
              title={compactMode ? "Naar uitgebreide weergave" : "Naar compacte weergave"}
            >
              {compactMode ? "📋 Uitgebreid" : "🗜️ Compact"}
            </button>
            <button
              className={"compact-toggle" + (kaartMode ? " actief" : "")}
              onClick={() => setKaartMode(k => !k)}
              title={kaartMode ? "Kaart verbergen" : "Geplande orders op de kaart"}
            >
              🗺️ Kaart
            </button>
          </div>
        </div>

        <div className="planning-container">
          {/* Ongeplande werkorders sidebar */}
          <div className="ongepland-sidebar">
            <h3>🗂️ Ongepland ({ongeplandeWerkorders.length})</h3>
            <input className="ongepland-zoek" type="text" placeholder="Zoek in ongepland..." value={ongeplandZoek} onChange={(e) => setOngeplandZoek(e.target.value)} />
            <div className="ongepland-lijst">
              {ongeplandeWerkorders.filter(wo => { const q = ongeplandZoek.trim().toLowerCase(); return !q || [wo.titel, wo.ordernummer, wo.klant_naam, wo.locatie_adres].some(v => v && String(v).toLowerCase().includes(q)); }).map(wo => (
                <div
                  key={wo.id}
                  className={'werkorder-card ongepland ' + (wo.herplan_count >= 2 ? 'herplan-rood' : wo.herplan_count === 1 ? 'herplan-oranje' : '') + (wo.prioriteit ? ' prio-' + wo.prioriteit : '')}
                  onClick={(e) => { e.stopPropagation(); setSelectedWerkorderId(wo.id); }}
                  draggable
                  onDragStart={(e) => handleDragStart(e, wo)}
                >
<div className="werkorder-title" title={(wo.ordernummer || '#' + wo.id) + ' \u00b7 ' + (wo.titel || '') + (wo.klant_naam ? ' \u00b7 ' + wo.klant_naam : '')}>{wo.prioriteit === 'hoog' ? '\u{1F534} ' : wo.prioriteit === 'normaal' ? '\u{1F7E1} ' : ''}{wo.titel ? wo.titel.substring(0, 32) : ((wo.ordernummer || '#' + wo.id) + ' ' + (wo.klant_naam || ''))}</div>
                  {wo.herplan_count > 0 && <span className="herplan-badge">{wo.herplan_count}x ⚠️</span>}
                  <div className="werkorder-meta">
                    <span className={'status-badge status-' + wo.status}>{wo.status}</span>
                    <span className={'prioriteit-' + wo.prioriteit}> </span>
                  </div>
                  {wo.locatie_adres && <div className="werkorder-locatie">📍 {wo.locatie_adres.substring(0, 30)}...</div>}
                </div>
              ))}
              {ongeplandeWerkorders.length === 0 && (
                <div className="empty-state">✅ Alles ingepland!</div>
              )}
            </div>
          </div>

          {/* Kalender grid */}
          <div className="kalender-grid">
            <div className="grid-header">
              <div className="monteur-col">Monteur</div>
              {weekDays.map((day, idx) => {
                const isToday = day.toDateString() === new Date().toDateString();
                const feestN = feestdagNaam(day);
                return (
                  <div key={idx} className={'day-col ' + (isToday ? 'today' : '') + (feestN ? ' feestdag' : '')} style={feestN ? { background: '#fff7ed', borderTop: '3px solid #ea580c' } : undefined} title={feestN || undefined}>
                    <div className="day-name">{day.toLocaleDateString('nl-NL', { weekday: 'short' })}</div>
                    {getVoertuigAfsprakenFor(null, day).map(a => (
                      <div key={'vah-' + a.id} title={(a.garage || '') + (a.notitie ? ' · ' + a.notitie : '')} style={{ fontSize: 10, color: '#5b21b6', background: '#ede9fe', borderRadius: 4, padding: '1px 4px', marginTop: 2, fontWeight: 600, whiteSpace: 'nowrap' }}>🚐 {a.kenteken} {VA_ICON[a.soort]}</div>
                    ))}
                    <div className="day-date">{day.getDate()}</div>
                    <div className="day-week" style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600 }}>wk{isoWeek(day)}</div>
                    {(() => {
                      const pad = n => String(n).padStart(2, '0');
                      const ds = day.getFullYear() + '-' + pad(day.getMonth() + 1) + '-' + pad(day.getDate());
                      const cnt = dagMeldingen.filter(x => (x.datum || '').slice(0, 10) === ds).length;
                      return cnt > 0 ? (
                        <div onClick={(e) => { e.stopPropagation(); setMeldingDatum(ds); }} title={cnt + ' mededeling(en)'} style={{ marginTop: 4, display: 'inline-flex', alignItems: 'center', gap: 3, background: '#0ea5e9', color: '#fff', borderRadius: 10, padding: '1px 7px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>📌 {cnt}</div>
                      ) : null;
                    })()}
                    {feestN && <div style={{ fontSize: '10px', color: '#9a3412', fontWeight: 600, marginTop: '2px', lineHeight: '1.1' }}>{feestN}</div>}
                  </div>
                );
              })}
            </div>

            {Object.values(verwachtOnderhoud).some(l => l.some(b => !b.monteur_id)) && (
              <div className="monteur-row" style={{ background: '#faf5ff' }}>
                <div className="monteur-col" style={{ background: '#faf5ff', borderLeft: '3px solid #a78bfa' }}>
                  <div onClick={() => setVerwachtOpen(o => !o)} style={{ fontWeight: 700, fontSize: 13, color: '#6d28d9', cursor: 'pointer', userSelect: 'none' }}>{verwachtOpen ? '\u25BE' : '\u25B8'} 🔮 Verwacht</div>
                  <div style={{ fontSize: 10, color: '#7c3aed' }}>{verwachtOpen ? 'sleep naar een monteur' : 'klik om te openen'}</div>
                </div>
                {weekDays.map((day, idx) => {
                  const k = vFmt(day);
                  const beurten = (verwachtOnderhoud[k] || []).filter(b => !b.monteur_id);
                  return (
                    <div key={idx} className="day-cell" style={{ background: '#faf5ff' }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={async (e) => {
                        const vid = e.dataTransfer.getData('verwacht_id');
                        if (!vid) return;
                        e.stopPropagation();
                        try { await api.put('/forecast/drukte/verwacht/' + vid + '/monteur', { monteur_id: null }); laadVerwacht(); }
                        catch (err) { alert('Loskoppelen mislukt: ' + (err.response?.data?.message || err.message)); }
                      }}>
                      {!verwachtOpen ? (beurten.length > 0 && (
                        <div onClick={() => setVerwachtOpen(true)} title="Klik om te openen"
                          style={{ padding: '2px 6px', borderRadius: 10, cursor: 'pointer', display: 'inline-block',
                                   background: '#ede9fe', color: '#6d28d9', fontSize: 11, fontWeight: 700 }}>
                          {beurten.length} {'\u00b7'} {beurten.reduce((t, b) => t + (parseFloat(b.uren) || 0), 0)}u
                        </div>
                      )) : beurten.map(b => b.type === 'werkorder' ? (
                        <div key={'wo' + b.id} draggable
                          onDragStart={(e) => { e.dataTransfer.setData('verwacht_wo_id', String(b.wo_id)); }}
                          title={'Uitgevallen werkorder — sleep naar een monteur (elke dag mag).'}
                          style={{ padding: '4px 6px', borderRadius: 4, marginTop: 2, cursor: 'grab',
                                   background: '#fffbeb', border: '1px dashed #f59e0b', color: '#92400e', fontSize: 11, fontWeight: 600 }}>
                          📋 {b.naam}{b.herplan_count > 0 ? ' ' + b.herplan_count + 'x ⚠️' : ''} · {b.uren}u
                        </div>
                      ) : (
                        <div key={b.id} draggable
                          onDragStart={(e) => { e.dataTransfer.setData('verwacht_id', String(b.id)); e.dataTransfer.setData('verwacht_datum', k); }}
                          title={'Verwacht onderhoud — datum vast. Sleep naar een monteur om alvast toe te wijzen.'}
                          style={{ padding: '4px 6px', borderRadius: 4, marginTop: 2, cursor: 'grab',
                                   background: '#f5f3ff', border: '1px dashed #a78bfa', color: '#6d28d9', fontSize: 11, fontWeight: 600 }}>
                          🔮 {b.naam}{b.dienst_type === 'nacht' ? ' 🌙' : ''} · {b.uren}u
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
            {monteurs.map((monteur, _mi) => {
              const _eersteOA = isOnderaannemer(monteur) && (_mi === 0 || !isOnderaannemer(monteurs[_mi - 1]));
              const isNacht = weekDays.some(d => heeftDienstOpDag(monteur, d, 'nacht'));
              const isStoring = weekDays.some(d => heeftDienstOpDag(monteur, d, 'storings'));

              // Bepaal achtergrondkleur monteur-info
              let monteurBg = '#f9fafb';
              let monteurBorder = 'none';
              let dienstLabel = '';
              if (isNacht) {
                monteurBg = dienstKleuren.nachtdienst_bg;
                monteurBorder = '3px solid ' + dienstKleuren.nachtdienst_border;
                dienstLabel = '🌙';
              }
              if (isStoring) {
                monteurBg = isNacht ? dienstKleuren.nachtdienst_bg : dienstKleuren.storingsdienst_bg;
                monteurBorder = isNacht ? monteurBorder : '3px solid ' + dienstKleuren.storingsdienst_border;
                dienstLabel += '🔴';
              }

              return (
                <React.Fragment key={monteur.id}>
                {_eersteOA && (
                  <div style={{ background: '#fff7ed', borderTop: '2px solid #f59e0b', padding: '5px 12px', fontSize: '12px', fontWeight: 700, color: '#b45309' }}>🏗️ Onderaannemers</div>
                )}
                <div className="monteur-row">
                  <div className="monteur-info" style={{ background: monteurBg, borderLeft: monteurBorder }}>
                    <div>
                      <strong>{monteur.voornaam} {monteur.achternaam}</strong>
                      {dienstLabel && <span style={{ marginLeft: '6px', fontSize: '14px' }}>{dienstLabel}</span>}
                      {viewMode === 'project' && monteur.afdeling_naam && (
                        <span style={{ marginLeft: 6, padding: '1px 6px', background: '#e0e7ff', color: '#3730a3', borderRadius: 4, fontSize: 10, fontWeight: 600, textTransform: 'uppercase' }}>
                          {monteur.afdeling_naam}
                        </span>
                      )}
                      {(isNacht || isStoring) && (
                        <div style={{ fontSize: '10px', color: isNacht ? dienstKleuren.nachtdienst_text : dienstKleuren.storingsdienst_text, marginTop: '2px' }}>
                          {isNacht && 'Nachtdienst'}
                          {isNacht && isStoring && ' + '}
                          {isStoring && 'Storingsdienst'}
                        </div>
                      )}
                    </div>
                  </div>
                  {weekDays.map((day, idx) => {
                    const dayWerkorders = getWerkordersForMonteurAndDate(monteur.id, day);
                    const dayCursussen = getCursussenForMonteurAndDate(monteur.id, day);
                    const dayCategoriePlanning = getCategoriePlanningForMonteurAndDate(monteur.id, day);
                    const rvVandaag = isRoosterVrij(monteur.id, day);
                    const _dayStr = vFmt(day);
                    const dayHuur = huurBlokken.filter(h => {
                      if (String(h.gekoppeld_monteur_id) !== String(monteur.id)) return false;
                      const vanStr = (h.datum_van || '').toString().slice(0,10);
                      const totStr = (h.datum_tot || '').toString().slice(0,10);
                      return vanStr <= _dayStr && totStr >= _dayStr;
                    });
                    const hasCursus = dayCursussen.length > 0;
                    const wachtCel = dayCategoriePlanning.find(cp => cp.categorie_id === 6) || null;
                    const nachtAfgemeldCel = dayCategoriePlanning.find(cp => cp.categorie_id === 9) || null;
                    const wachtAfgemeldCel = dayCategoriePlanning.find(cp => cp.categorie_id === 11) || null;
                    const nachtExtraCel = dayCategoriePlanning.find(cp => cp.categorie_id === 10) || null;
                    const heeftWachtCel = !!wachtCel;
                    const nachtDag = heeftDienstOpDag(monteur, day, 'nacht');
                    const storingDag = heeftDienstOpDag(monteur, day, 'storings');

                    const isFeest = isFeestdag(day);
                    return (
                      <div
                        key={idx}
                        className={"day-cell" + (isFeest ? " feestdag-cell" : "")}
                        style={{ position: 'relative', ...(isFeest && !nachtDag && !storingDag && !hasCursus ? { background: '#fff7ed' } : {}), ...((((nachtDag && !nachtAfgemeldCel) || nachtExtraCel)) && !hasCursus ? { background: dienstKleuren.nachtdienst_bg } : {}), ...(storingDag && !wachtAfgemeldCel && !nachtDag && !hasCursus ? { background: dienstKleuren.storingsdienst_bg } : {}), ...(hasCursus ? { background: dienstKleuren.cursus_bg, borderColor: dienstKleuren.cursus_border, borderStyle: 'solid', borderWidth: '2px' } : {}), ...(heeftWachtCel && !hasCursus ? { background: dienstKleuren.storingsdienst_bg } : {}) }}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, day, monteur.id)}
                      >
                        {!wachtCel && storingDag && !wachtAfgemeldCel && !nachtDag && nachtConfirm !== ('waf|' + monteur.id + '|' + vFmt(day)) && (
                          <div onClick={(e) => { e.stopPropagation(); setNachtConfirm('waf|' + monteur.id + '|' + vFmt(day)); }}
                            title="Wachtdienst afmelden"
                            style={{ position: 'absolute', top: 2, right: 5, cursor: 'pointer', fontSize: 11,
                                     color: '#92400e', fontWeight: 700, opacity: 0.6, zIndex: 5 }}>{'\u2715'}</div>
                        )}
                        {nachtConfirm === ('waf|' + monteur.id + '|' + vFmt(day)) && (
                          <div style={{ padding: '4px 6px', borderRadius: 6, background: '#fff7ed', border: '1px solid #fdba74', fontSize: 11, marginBottom: 2 }}>
                            Wacht afmelden?{' '}
                            <button onClick={async (e) => { e.stopPropagation();
                                try { await api.post('/categorie-planning', { categorie_id: 11, gebruiker_ids: [monteur.id], gepland_op: vFmt(day), aantal_uren: 8 });
                                  setNachtConfirm(null); fetchData(); } catch (err) { alert('Fout: ' + err.message); } }}
                              style={{ marginLeft: 4, background: '#f59e0b', color: 'white', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>Deze dag</button>
                            <button onClick={async (e) => { e.stopPropagation();
                                try {
                                  const ma = new Date(day); ma.setDate(ma.getDate() - ((ma.getDay() + 6) % 7));
                                  for (let i = 0; i < 7; i++) { const d2 = new Date(ma); d2.setDate(d2.getDate() + i);
                                    await api.post('/categorie-planning', { categorie_id: 11, gebruiker_ids: [monteur.id], gepland_op: vFmt(d2), aantal_uren: 8 }); }
                                  setNachtConfirm(null); fetchData(); } catch (err) { alert('Fout: ' + err.message); } }}
                              style={{ marginLeft: 4, background: '#b45309', color: 'white', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>Hele week</button>
                            <button onClick={(e) => { e.stopPropagation(); setNachtConfirm(null); }}
                              style={{ marginLeft: 4, background: '#e2e8f0', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Nee</button>
                          </div>
                        )}
                        {wachtAfgemeldCel && nachtConfirm !== ('wher|' + wachtAfgemeldCel.id) && (
                          <div onClick={(e) => { e.stopPropagation(); setNachtConfirm('wher|' + wachtAfgemeldCel.id); }}
                            title="Klik om de afmelding te herstellen"
                            style={{ padding: '2px 6px', borderRadius: 4, background: '#f1f5f9', border: '1px dashed #94a3b8',
                                     fontSize: 10, color: '#64748b', fontWeight: 600, marginBottom: 2, cursor: 'pointer', display: 'inline-block' }}>
                            {'\uD83D\uDD34\u2715'} afgemeld
                          </div>
                        )}
                        {wachtAfgemeldCel && nachtConfirm === ('wher|' + wachtAfgemeldCel.id) && (
                          <div style={{ padding: '4px 6px', borderRadius: 6, background: '#f0fdf4', border: '1px solid #86efac', fontSize: 11, marginBottom: 2 }}>
                            Afmelding herstellen?{' '}
                            <button onClick={async (e) => { e.stopPropagation();
                                try { await api.delete('/categorie-planning/' + wachtAfgemeldCel.id); setNachtConfirm(null); fetchData(); }
                                catch (err) { alert('Fout: ' + err.message); } }}
                              style={{ marginLeft: 4, background: '#16a34a', color: 'white', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>Ja</button>
                            <button onClick={(e) => { e.stopPropagation(); setNachtConfirm(null); }}
                              style={{ marginLeft: 4, background: '#e2e8f0', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Nee</button>
                          </div>
                        )}
                        {!wachtCel && nachtDag && !nachtAfgemeldCel && nachtConfirm !== ('af|' + monteur.id + '|' + vFmt(day)) && (
                          <div onClick={(e) => { e.stopPropagation(); setNachtConfirm('af|' + monteur.id + '|' + vFmt(day)); }}
                            title="Nachtdienst afmelden"
                            style={{ position: 'absolute', top: 2, right: 5, cursor: 'pointer', fontSize: 11,
                                     color: '#5b21b6', fontWeight: 700, opacity: 0.6, zIndex: 5 }}>{'\u2715'}</div>
                        )}
                        {nachtConfirm === ('af|' + monteur.id + '|' + vFmt(day)) && (
                          <div style={{ padding: '4px 6px', borderRadius: 6, background: '#f5f3ff', border: '1px solid #a78bfa', fontSize: 11, marginBottom: 2 }}>
                            Nacht afmelden?{' '}
                            <button onClick={async (e) => { e.stopPropagation();
                                try { await api.post('/categorie-planning', { categorie_id: 9, gebruiker_ids: [monteur.id], gepland_op: vFmt(day), aantal_uren: 8 });
                                  setNachtConfirm(null); fetchData(); } catch (err) { alert('Fout: ' + err.message); } }}
                              style={{ marginLeft: 4, background: '#7c3aed', color: 'white', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>Deze dag</button>
                            <button onClick={async (e) => { e.stopPropagation();
                                try {
                                  const zo = new Date(day); zo.setDate(zo.getDate() - zo.getDay());
                                  for (let i = 0; i < 5; i++) { const d2 = new Date(zo); d2.setDate(d2.getDate() + i);
                                    await api.post('/categorie-planning', { categorie_id: 9, gebruiker_ids: [monteur.id], gepland_op: vFmt(d2), aantal_uren: 8 }); }
                                  setNachtConfirm(null); fetchData(); } catch (err) { alert('Fout: ' + err.message); } }}
                              style={{ marginLeft: 4, background: '#4c1d95', color: 'white', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>Hele week</button>
                            <button onClick={(e) => { e.stopPropagation(); setNachtConfirm(null); }}
                              style={{ marginLeft: 4, background: '#e2e8f0', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Nee</button>
                          </div>
                        )}
                        {nachtAfgemeldCel && nachtConfirm !== ('her|' + nachtAfgemeldCel.id) && (
                          <div onClick={(e) => { e.stopPropagation(); setNachtConfirm('her|' + nachtAfgemeldCel.id); }}
                            title="Klik om de afmelding te herstellen"
                            style={{ padding: '2px 6px', borderRadius: 4, background: '#f1f5f9', border: '1px dashed #94a3b8',
                                     fontSize: 10, color: '#64748b', fontWeight: 600, marginBottom: 2, cursor: 'pointer', display: 'inline-block' }}>
                            {'\uD83C\uDF19\u2715'} afgemeld
                          </div>
                        )}
                        {nachtAfgemeldCel && nachtConfirm === ('her|' + nachtAfgemeldCel.id) && (
                          <div style={{ padding: '4px 6px', borderRadius: 6, background: '#f0fdf4', border: '1px solid #86efac', fontSize: 11, marginBottom: 2 }}>
                            Afmelding herstellen?{' '}
                            <button onClick={async (e) => { e.stopPropagation();
                                try { await api.delete('/categorie-planning/' + nachtAfgemeldCel.id); setNachtConfirm(null); fetchData(); }
                                catch (err) { alert('Fout: ' + err.message); } }}
                              style={{ marginLeft: 4, background: '#16a34a', color: 'white', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>Ja</button>
                            <button onClick={(e) => { e.stopPropagation(); setNachtConfirm(null); }}
                              style={{ marginLeft: 4, background: '#e2e8f0', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Nee</button>
                          </div>
                        )}
                        {nachtExtraCel && (
                          <div onClick={(e) => { e.stopPropagation();
                              if (nachtConfirm === ('ext|' + nachtExtraCel.id)) return; setNachtConfirm('ext|' + nachtExtraCel.id); }}
                            style={{ padding: '2px 6px', borderRadius: 4, background: '#ede9fe', border: '1px solid #a78bfa',
                                     fontSize: 10, color: '#5b21b6', fontWeight: 700, marginBottom: 2, cursor: 'pointer', display: 'inline-block' }}>
                            {'\uD83C\uDF19'}+ extra {nachtConfirm === ('ext|' + nachtExtraCel.id) && (
                              <>
                                <button onClick={async (e) => { e.stopPropagation();
                                    try { await api.delete('/categorie-planning/' + nachtExtraCel.id); setNachtConfirm(null); fetchData(); }
                                    catch (err) { alert('Fout: ' + err.message); } }}
                                  style={{ marginLeft: 4, background: '#dc2626', color: 'white', border: 'none', borderRadius: 4, padding: '1px 6px', fontSize: 10, fontWeight: 700, cursor: 'pointer' }}>weghalen</button>
                                <button onClick={(e) => { e.stopPropagation(); setNachtConfirm(null); }}
                                  style={{ marginLeft: 2, background: '#e2e8f0', border: 'none', borderRadius: 4, padding: '1px 6px', fontSize: 10, cursor: 'pointer' }}>houden</button>
                              </>
                            )}
                          </div>
                        )}
                        {wachtCel && wachtConfirm !== wachtCel.id && (
                          <div onClick={(e) => { e.stopPropagation(); setWachtConfirm(wachtCel.id); }}
                            title="Wachtdienst verwijderen"
                            style={{ position: 'absolute', top: 2, right: 5, cursor: 'pointer', fontSize: 11,
                                     color: '#92400e', fontWeight: 700, opacity: 0.6, zIndex: 5 }}>{'\u2715'}</div>
                        )}
                        {wachtCel && wachtConfirm === wachtCel.id && (
                          <div style={{ padding: '4px 6px', borderRadius: 6, background: '#fff7ed',
                                        border: '1px solid #fdba74', fontSize: 11, marginBottom: 2 }}>
                            Wachtdienst weghalen?{' '}
                            <button onClick={(e) => { e.stopPropagation();
                                api.delete('/categorie-planning/' + wachtCel.id)
                                  .then(() => { setWachtConfirm(null); fetchData(); })
                                  .catch(err => alert('Fout: ' + err.message)); }}
                              style={{ marginLeft: 4, background: '#dc2626', color: 'white', border: 'none',
                                       borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>Ja</button>
                            <button onClick={(e) => { e.stopPropagation(); setWachtConfirm(null); }}
                              style={{ marginLeft: 4, background: '#e2e8f0', border: 'none', borderRadius: 4,
                                       padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Nee</button>
                          </div>
                        )}
                        {(verwachtOnderhoud[vFmt(day)] || []).filter(b => b.monteur_id === monteur.id).map(b => (
                          <div key={'v-' + b.id} draggable
                            onDragStart={(e) => { e.dataTransfer.setData('verwacht_id', String(b.id)); e.dataTransfer.setData('verwacht_datum', vFmt(day)); }}
                            title={'Verwacht onderhoud (nog geen werkorder) — wordt ~2 weken vooraf automatisch aangemaakt en aan deze monteur toegewezen.'}
                            style={{ padding: '4px 6px', borderRadius: 4, marginTop: 2, cursor: 'grab',
                                     background: '#f5f3ff', border: '1px dashed #a78bfa', color: '#6d28d9', fontSize: 11, fontWeight: 600 }}>
                            🔮 {b.naam}{b.dienst_type === 'nacht' ? ' 🌙' : ''} · {b.uren}u
                          </div>
                        ))}
                        {/* Voertuig-afspraken (bestuurder) */}
                        {getVoertuigAfsprakenFor(monteur.id, day).map(a => (
                          <div key={'va-' + a.id} title={(a.garage || '') + (a.notitie ? ' · ' + a.notitie : '')} style={{ padding: '4px 6px', borderRadius: '4px', background: '#ede9fe', border: '1px solid #8b5cf6', fontSize: '11px', color: '#5b21b6', fontWeight: '600', marginBottom: 2 }}>
                            🚐 {a.kenteken} · {VA_ICON[a.soort]} {VA_LABEL[a.soort] || a.soort}{a.tijd ? ' ' + a.tijd : ''}
                          </div>
                        ))}
                        {/* Cursussen bovenaan */}
                        {dayCursussen.map(c => (
                          <div key={'c-' + c.id} style={{ padding: '4px 6px', borderRadius: '4px', background: dienstKleuren.cursus_bg, border: '1px solid ' + dienstKleuren.cursus_border, fontSize: '11px', color: dienstKleuren.cursus_text, fontWeight: '600' }}>
                            🎓 {c.naam}{c.geaccepteerd_op ? <span title={'Geaccepteerd ' + new Date(c.geaccepteerd_op).toLocaleString('nl-NL')}> ✅</span> : c.gezien_op ? <span title={'Gezien ' + new Date(c.gezien_op).toLocaleString('nl-NL') + ', nog niet geaccepteerd'}> 👁</span> : null}
                          </div>
                        ))}
                        {rvVandaag && (
                          <div style={{ padding: '4px 6px', borderRadius: 4, background: '#f1f5f9', border: '1px dashed #94a3b8', fontSize: 11, color: '#475569', fontWeight: 600, marginTop: 2 }} title="Rooster-vrije dag">
                            {'🗓️'} Rooster-vrij
                          </div>
                        )}
                        {/* Categorie planning (werkoverleg/wagenpark/etc) */}
                        {dayCategoriePlanning.filter(cp => ![6, 9, 10, 11].includes(cp.categorie_id)).map(cp => (
                          <div
                            key={'cp-' + cp.id}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (window.confirm('Verwijder ' + cp.categorie_titel + ' (' + cp.aantal_uren + 'u)?')) {
                                api.delete('/categorie-planning/' + cp.id).then(() => fetchData()).catch(err => alert('Fout: ' + err.message));
                              }
                            }}
                            style={{ padding: '4px 6px', borderRadius: 4, background: cp.categorie_id === 6 ? '#fef3c7' : cp.categorie_id === 5 ? '#fee2e2' : cp.categorie_id === 4 ? '#ede9fe' : dienstKleuren.categorie_bg, border: '1px solid ' + (cp.categorie_id === 6 ? '#f59e0b' : cp.categorie_id === 5 ? '#ef4444' : cp.categorie_id === 4 ? '#7c3aed' : dienstKleuren.categorie_border), fontSize: 11, color: cp.categorie_id === 6 ? '#92400e' : cp.categorie_id === 5 ? '#991b1b' : cp.categorie_id === 4 ? '#5b21b6' : dienstKleuren.categorie_text, fontWeight: 600, marginTop: 2, cursor: 'pointer' }}
                            title={cp.categorie_titel + ' (' + cp.sap_code + ')' + (cp.ordernummer ? ' · order: ' + cp.ordernummer : '') + (cp.opmerking ? ' · ' + cp.opmerking : '') + ' - klik om te verwijderen'}
                          >
                            {cp.categorie_id === 6 ? '🔴 ' + cp.categorie_titel : '📋 ' + cp.categorie_titel + ' (' + cp.aantal_uren + 'u)' + (cp.ordernummer ? ' · ' + cp.ordernummer : '') + (cp.opmerking ? ' · ' + (cp.opmerking.length > 20 ? cp.opmerking.substring(0, 20) + '…' : cp.opmerking) : '')}
                          </div>
                        ))}
                        {/* Inhuur badges */}
                        {dayHuur.map(h => (
                          <div key={'h-' + h.id} style={{ padding: '3px 6px', borderRadius: 4, background: (h.resource_kleur||'#f59e0b')+'33', border: '1px dashed '+(h.resource_kleur||'#f59e0b'), fontSize: 10, color: '#78350f', fontWeight: 700, marginTop: 2 }} title={h.resource_naam + ' (status: ' + h.status + ')'}>
                            🤝 {h.aantal}× {h.resource_naam}
                          </div>
                        ))}
                        {/* Werkorders */}
                        {dayWerkorders.map(wo => (
                          <div
                            key={wo.planning_id || wo.id}
                            className={'werkorder-card ' + (wo.status === 'afgerond' ? 'afgerond' : 'actief') + (wo.prioriteit ? ' prio-' + wo.prioriteit : '')}
                            draggable
                            onDragStart={(e) => handleDragStart(e, wo)}
                            title={wo.titel + ' - ' + wo.status + ' (klik rechts om te verwijderen)'}
                            onClick={(e) => { e.stopPropagation(); setSelectedWerkorderId(wo.id); }}
                            onContextMenu={(e) => handleVerwijderVanDag(wo, e)}
                          >
                            <div className="werkorder-title" title={(wo.ordernummer || '#' + wo.id) + ' \u00b7 ' + (wo.titel || '') + (wo.klant_naam ? ' \u00b7 ' + wo.klant_naam : '')}>{wo.prioriteit === 'hoog' ? '\u{1F534} ' : wo.prioriteit === 'normaal' ? '\u{1F7E1} ' : ''}{wo.titel ? wo.titel.substring(0, 32) : ((wo.ordernummer || '#' + wo.id) + ' ' + (wo.klant_naam || ''))}</div>
                            <div className="werkorder-status">
                              {wo.status === 'afgerond' ? '✅' : '⏳'}
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>

        <div className="legenda">
          <h4>Legenda:</h4>
          <div className="legenda-items">
            <div><span className="legenda-box actief"></span> Actieve werkorder</div>
            <div><span className="legenda-box afgerond"></span> Afgeronde werkorder</div>
            <div><span className="legenda-box ongepland"></span> Ongepland</div>
            <div><span className="legenda-box" style={{ background: dienstKleuren.nachtdienst_bg, border: '2px solid ' + dienstKleuren.nachtdienst_border }}></span> 🌙 Nachtdienst</div>
            <div><span className="legenda-box" style={{ background: dienstKleuren.storingsdienst_bg, border: '2px solid ' + dienstKleuren.storingsdienst_border }}></span> 🔴 Storingsdienst</div>
            <div><span className="legenda-box" style={{ background: dienstKleuren.cursus_bg, border: '2px solid ' + dienstKleuren.cursus_border }}></span> 🎓 Cursus/Opleiding</div>
            <div><span className="legenda-box" style={{ background: '#ede9fe', border: '2px solid #8b5cf6' }}></span> 🚐 Voertuig-afspraak</div>
          </div>
          <p style={{marginTop: '10px', fontSize: '12px', color: '#666'}}>
            💡 Tip: Sleep naar dag om toe te voegen. Rechtermuisklik om van dag te verwijderen.
          </p>
        </div>

        {showWerkorderModal && (
          <WerkorderModal
            show={showWerkorderModal}
            onClose={() => setShowWerkorderModal(false)}
            onSave={() => {
              setShowWerkorderModal(false);
              fetchData();
            }}
          />
        )}
      </div>

      {selectedWerkorderId && (
        <WerkorderDetailModal
          werkorderId={selectedWerkorderId}
          onClose={() => setSelectedWerkorderId(null)}
          onUpdate={fetchData}
        />
      )}

      <CategoriePlanModal
        isOpen={showCategorieModal}
        onClose={() => setShowCategorieModal(false)}
        onSuccess={(count) => { fetchData(); alert('✓ ' + count + ' planning-items aangemaakt'); }}
        monteurs={monteurs}
        defaultDate={vFmt(getMonday(currentWeek))}
      />

      {/* Drop keuze modal */}
      {showDropModal && dropInfo && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '400px',
            width: '90%',
            textAlign: 'center'
          }}>
            <h3 style={{ marginBottom: '10px' }}>📅 Werkorder #{dropInfo.werkorder.id}</h3>
            <p style={{ marginBottom: '20px', color: '#666' }}>
              Wat wil je doen met deze werkorder?
            </p>
            <p style={{ marginBottom: '20px', fontWeight: 'bold' }}>
              Nieuwe datum: {dropInfo.datum.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' })}
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <button
                onClick={() => handleDropModalChoice('toevoegen')}
                style={{
                  padding: '15px',
                  borderRadius: '8px',
                  border: 'none',
                  background: '#10b981',
                  color: 'white',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}
              >
                📋 Toevoegen (staat op beide dagen)
              </button>
              <button
                onClick={() => handleDropModalChoice('verplaatsen')}
                style={{
                  padding: '15px',
                  borderRadius: '8px',
                  border: 'none',
                  background: '#3b82f6',
                  color: 'white',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}
              >
                📦 Verplaatsen (oude dag wordt verwijderd)
              </button>
              <button
                onClick={() => { setShowDropModal(false); setDropInfo(null); setDraggedWerkorder(null); }}
                style={{
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid #d1d5db',
                  background: 'white',
                  cursor: 'pointer',
                  marginTop: '10px'
                }}
              >
                Annuleren
              </button>
            </div>
          </div>
        </div>
      )}
      {showOvertijdModal && overtijdInfo && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000
        }}>
          <div style={{
            background: "white",
            padding: "30px",
            borderRadius: "12px",
            maxWidth: "450px",
            width: "90%",
            textAlign: "center"
          }}>
            <h3 style={{ marginBottom: "10px", color: "#f59e0b" }}>⚠️ Let op: Overtijd!</h3>
            <p style={{ marginBottom: "15px", color: "#666" }}>
              Deze monteur heeft al <strong>{overtijdInfo.huidigeUren} uur</strong> gepland.
            </p>
            <p style={{ marginBottom: "15px" }}>
              Toevoegen van <strong>{overtijdInfo.nieuweUren} uur</strong> geeft totaal <strong style={{ color: "#dc2626" }}>{overtijdInfo.totaalUren} uur</strong>
            </p>
            <p style={{ marginBottom: "20px", fontSize: "14px", color: "#666" }}>
              (Maximum is 8 uur per dag)
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <button
                onClick={() => {
                  setShowOvertijdModal(false);
                  if (!overtijdInfo.werkorder.planning_id) {
                    doPlannen("toevoegen", overtijdInfo.datum, overtijdInfo.monteurId);
                  } else {
                    setDropInfo({ datum: overtijdInfo.datum, monteurId: overtijdInfo.monteurId, werkorder: overtijdInfo.werkorder });
                    setShowDropModal(true);
                  }
                  setOvertijdInfo(null);
                }}
                style={{
                  padding: "15px",
                  borderRadius: "8px",
                  border: "none",
                  background: "#f59e0b",
                  color: "white",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "16px"
                }}
              >
                ✅ Toch inplannen
              </button>
              <button
                onClick={() => { setShowOvertijdModal(false); setOvertijdInfo(null); setDraggedWerkorder(null); }}
                style={{
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",
                  background: "white",
                  cursor: "pointer"
                }}
              >
                Annuleren
              </button>
            </div>
          </div>
        </div>
      )}
          <DrukteKalender />
      </div>
  );
};

export default WerkvoorbereiderPlanning;

